import { providerList } from '@blax-modules/base-front-end/resources/js/utilities/providers';

import {CtaParallax} from "@blax-modules/base-front-end/resources/js/ui/cta-parallax";
providerList.instantiate('CtaParallax', CtaParallax);